import Doc from '@/models/Doc'
import { LocalStorageFacade } from 'paliari-js-utils'

export default {
  props: {
    docTipo: { type: String },
    steps: Array,
    edit: { type: Boolean, default: false },
    revisao: { type: Boolean, default: false },
  },
  data() {
    return { resource: null }
  },
  computed: {
    nextStepRoute() {
      const actualIndex = this.steps.findIndex(
        ({ routeName }) => routeName === this.$route.name,
      )

      if (actualIndex === -1) return ''

      const nextStep = this.steps[actualIndex + 1]

      return nextStep ? nextStep.routeName : ''
    },
  },
  methods: {
    navigate(routeName, params = {}) {
      LocalStorageFacade.setItem('doc', this.resource)
      this.$router.push({
        name: routeName,
        params: { ...this.$route.params, ...params },
      })
    },
    next(params = {}) {
      this.navigate(this.nextStepRoute, params)
    },
    setResource(resource) {
      this.$set(this, 'resource', resource)
    },
  },
  created() {
    const { docTipo } = this
    const params = LocalStorageFacade.getItem('doc') || {}
    this.setResource(new Doc(params))
  },
}
